import axios from 'axios';

export default class RecaptchaService
{
    public static async fetch()
    {
        return (await axios.get<Record<string, any>>(`auth/recaptcha`)).data;
    }

    public static async testSettings(captchaResult: string, privateKey: string)
    {
        return (await axios.post<boolean>(`admin/recaptcha/test/`, { captchaResult, privateKey })).data;
    }
}
